import { render, staticRenderFns } from "./courseTypeSelect.vue?vue&type=template&id=2bcf02ac"
import script from "./courseTypeSelect.vue?vue&type=script&lang=js"
export * from "./courseTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports